import type { PackageOptionField } from './types';

export const PACKAGE_OPTION_FIELDS: Array<PackageOptionField> = [];
